import { useCallback, useMemo } from 'react';
import { useService } from '@atlassian/jira-common-services/src/use-service';
import { performGetRequest } from '@atlassian/jira-fetch';
import type { FetchContactAdminDetailsResponse } from '../types';
import { getFetchContactAdminDetailsURL, defaultStateForContactAdminDetails } from '../utils';

export const useContactAdministratorDetails = () => {
	const request = useCallback(() => performGetRequest(getFetchContactAdminDetailsURL()), []);
	const {
		loading,
		error,
		data = defaultStateForContactAdminDetails,
		fetch,
	} = useService<FetchContactAdminDetailsResponse, undefined>(request);
	const memoisedData = useMemo(() => data, [data]);
	return {
		loading,
		error,
		data: memoisedData,
		fetchContactAdminDetails: fetch,
	};
};
